import { IMappers } from '../../../repositories/cpd/v1/create-cpd-draft';

export const mappers: IMappers<true, false> = {
  200: () => true,
  400: () => false,
};
